<template>

  <v-autocomplete v-model="categoryAge"
                  label="Age"
                  :placeholder="placeholder"
                  :items="categories"
                  item-text="age"
                  item-value="age"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"></v-autocomplete>

</template>

<script>

export default {
  name: 'CategoryAgeSelector',
  props: ['federationID', 'currentCategoryAge', 'disabledText'],
  data () {
    return {
      loading: false,
      categories: [],
      categoryAge: ''
    }
  },
  mounted () {
    if (this.federationID) {
      this.loadCategoryAges()
    }

    if (this.currentCategoryAge) {
      this.categoryAge = this.currentCategoryAge
    }
  },
  methods: {
    loadCategoryAges () {
      let age = ''
      if (!this.currentCategoryAge) {
        this.$emit('categoryAgeSelected', '')
      } else {
        age = this.currentCategoryAge
      }

      if (this.federationID) {
        this.loading = true
        this.$store.dispatch('getFederationCategories', this.federationID)
          .then(resp => {
            this.categories = resp
            if (age) {
              this.categoryAge = age
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading categories')
          })
      } else {
        this.clear()
      }
    },
    clear () {
      this.categoryAge = ''
      this.categories = []
    }
  },
  computed: {
    isDisabled () {
      return this.categories.length === 0
    },
    placeholder () {
      return this.isDisabled ? this.disabledText || 'Please select a club first' : 'Age'
    }
  },
  watch: {
    'federationID' () {
      this.clear()
      this.loadCategoryAges()
    },
    'categoryAge' () {
      this.$emit('categoryAgeSelected', this.categoryAge || '')
    },
    'currentCategoryAge' () {
      if (this.currentCategoryAge) {
        this.categoryAge = this.currentCategoryAge
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/CategoryAgeSelector.vue